import MyEvents from './MyEvents';

export default MyEvents;
